export default __webpack_public_path__ + "static/placement-do-light-f1b16ad974e2c06ab30a903ace8ea8d4.png";